"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intents = exports.intentNames = void 0;

var _CheckCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/CheckCircle"));

var _ExclamationCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationCircle"));

var _ExclamationTriangle = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationTriangle"));

var _InfoCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/InfoCircle"));

var _commonUIColors = require("./utils/commonUIColors");

var _intents;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dangerColor = _commonUIColors.commonUIColors.danger,
    informationColor = _commonUIColors.commonUIColors.information,
    successColor = _commonUIColors.commonUIColors.success,
    warningColor = _commonUIColors.commonUIColors.warning;
var intentNames;
exports.intentNames = intentNames;

(function (intentNames) {
  intentNames["danger"] = "danger";
  intentNames["information"] = "information";
  intentNames["success"] = "success";
  intentNames["warning"] = "warning";
})(intentNames || (exports.intentNames = intentNames = {}));

var intents = (_intents = {}, _defineProperty(_intents, intentNames.danger, {
  color: dangerColor,
  icon: _ExclamationTriangle.default
}), _defineProperty(_intents, intentNames.information, {
  color: informationColor,
  icon: _InfoCircle.default
}), _defineProperty(_intents, intentNames.success, {
  color: successColor,
  icon: _CheckCircle.default
}), _defineProperty(_intents, intentNames.warning, {
  color: warningColor,
  icon: _ExclamationCircle.default
}), _intents);
exports.intents = intents;